<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item"><router-link to="/siswa/paket-belajar">Paket Belajar</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Invoice</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Invoice</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
                
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">

                            <div class="card" >
                                <iframe id="invoiceIframe" v-bind:src="invoice" width="100%" height="700" frameborder="0">
                                </iframe>
                            </div>
                            
						</div>
                    </div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
			

	</div>
		<!-- /Main Wrapper -->
</template>


<script>
// import instructors from '../../../assets/json/instructorslist'
// const images = require.context('@/assets/img/clients', false, /\.png$|\.jpg$/)
// import schoolvisits from '../../../assets/json/instructor/dashboard/schoolvisits'
// import coursetakenrecords from '../../../assets/json/instructor/dashboard/coursetakenrecords'
// import billing from '../../../assets/json/instructor/dashboard/billing'

import Sidebar from '../../Sidebar'
import axios from 'axios';
import axiosXendit from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'paket-belajar',
    // vuetify: new Vuetify(),
    data() {
        return {
            invoice:'',
            paketsales: '',
        }
    },
    created: function () {
        this.getInvoice();
    },  

    methods: {
        
        iframeStyles() {
            this.frame = this.$refs.iframeContent.contentWindow;
            const style = '.bg-header{display:none} ';
            this.frame.postMessage(style, '*');
        },
        
        getInvoice: function () {
							
             axios.get('api/invoice/'+localStorage.getItem("idPaket"))// this.$route.params.id)
                .then(res => {
                    this.paketsales = res.data.data;
                    // console.log(this.paketsales);
                    this.invoice = "https://checkout.xendit.co/web/"+this.paketsales.inv_id;
                    // axios.get('/api/invoice/624a781e252f9f70fc857097')
                    // .then(res => {
                    //     console.log(res.data);
                    //     this.invoice = res.data.data;
                    //     // this.initDt("tblLatihan");
                    // })
                    // .catch(err => {
                    //     // handle error
                    //     console.log(err);
                    // })
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })

        },

        // createInvoice: function () {
        //     axios.post('/invoices' ,{
        //             external_id: "invoicepp-test123",
        //             amount: 300000,
        //             payer_email: "siswa@gmail.com",
        //             description: "Test Invoice #321"
        //             },
        //             {
        //                 headers: {
        //                     Authorization: 'Basic eG5kX2RldmVsb3BtZW50X2NXaE85TU85WFM3R3VTUnJMU2RycVp5WkNyN0RVdURwcnJTandiVGszV2lKWlYzOE54eXBmMUprR3FURlU1Og=='
        //                 }
        //             }
        //         )
        //         .then(res => {
        //             console.log("ini hasil create invoice");
        //             console.log(res.data);
        //             // this.paket = res.data.data;
        //             // this.initDt("tblLatihan");
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Siswa/PaketBelajar/Invoice/index.vue